import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'

export function getName(){
  return 'archive/userLogs'
}

export function getTableColumns(o,item){

  var columns = [
    {
      id: 'uid',
      value: item.uid,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'email',
      value: item.email,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'role',
      value: item.role,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'event',
      value: item.event,
      type: o.type.text,
      width: 200,
    },
    {
      id: 'value',
      value: item.value,
      type: o.type.text,
      width: 300,
    },
    {
      id: 'data',
      value: item.data,
      type: o.type.text,
      width: 300,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
      width: 150,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.userLogs,

      function(item){

        var model = o.model.aUserLogs
        var columns = model.getTableColumns(o,item)

        return {
          columns: columns,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var fields = [
    {
      id: 'uid',
      value: item.uid,
      type: 'text',
    },
    {
      id: 'event',
      value: item.event,
      type: 'text',
    },
    {
      id: 'data',
      value: item.author,
      type: 'text',
    },
    {
      id: 'date',
      value: item.date,
      type: 'date',
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function insert(o,item,done){

}

export function update(o,id,changes,done){

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aUserLogs/aUserLogs.js